import { Cents, cents } from '@systemeio/ui'
import {
  BillingPeriodCaptionEnum,
  BillingPeriodEnum,
  SubscriptionPeriodEnum,
} from 'modules/profile/user-plan/enums/billing-period-enum'
import { UserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface'

export function getPricePlanParams(
  pricePlan: UserPlanInterface,
): {
  cost: Cents
  paymentPageUrl: string
  periodLabel: string
} {
  const cost = pricePlan.price?.amount || cents(0)

  const periodLabel = pricePlan.price
    ? pricePlan.price.interval === SubscriptionPeriodEnum.month
      ? BillingPeriodCaptionEnum[BillingPeriodEnum.monthly]
      : BillingPeriodCaptionEnum[BillingPeriodEnum.annual]
    : BillingPeriodCaptionEnum[BillingPeriodEnum.monthly]

  return {
    cost,
    paymentPageUrl: pricePlan.paymentPageUrl || '',
    periodLabel,
  }
}
